import React from 'react';
import DataTableX from '../../components/datatable/DataTableX';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';





const  OperationDatatable = (props) => {

    const [t] = useTranslation();     
 
    const tableName = ''; // t('workOrder.label.operations'); 
   
    const columns = [       
             { name: "Id", data: "id", selector: "id", omit: true},
             { name: t('general.label.name'), data: "name", sortable: true, selector: "name", minWidth: '500px'},    		
             { name: t('workOrder.label.numberShort'), data: "nbr", sortable: true, selector: "nbr"},    		
             { name: t('workOrder.label.resourceName'), data: "resource.name", sortable: true, selector: "resource.name"},    		
             { name: t('workOrder.label.durationMachine'), data: "durationMachine",  sortable: true,  selector: "durationMachine"},
             { name: t('workOrder.label.durationOperator'), data: "durationOperator",  sortable: true,  selector: "durationOperator"},             
             { name: t('general.label.description'), data: "description", sortable: true,  selector: "description"}
     ];        
 
 
         
     const columnsData = [       
         { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
         { name: t('general.label.name'), data: "name",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
         { name: t('workOrder.label.numberShort'), data: "nbr", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('workOrder.label.resourceName'), data: "resource.name", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('workOrder.label.durationMachine'), data: "durationMachine", orderable: true,  searchable: true, search: {value: '',regex: false}},                 
         { name: t('workOrder.label.durationOperator'), data: "durationOperator", orderable: true,  searchable: true, search: {value: '',regex: false}},       
         { name: t('general.label.description'), data: "description", orderable: true,  searchable: true, search: {value: '',regex: false}}                 
     ];        
     const url = RestService.getBaseURL()+"workOrder/getOperationList";   
     const urlExcel = RestService.getBaseURL()+"";          
    
   
 
   

     const handleCallback  = (id) => {
             props.parentCallback(id);                   
     };
   
          
    
         return (
           
             <DataTableX
                 url={url}  
                 urlExcel={urlExcel}  
                 tableName={tableName}
                 columns={columns}   
                 columnsData={columnsData}
                 parentCallback={handleCallback}
                 modalShow={props.modalShow}
                 exportShow={false}
             />
           
         );
    
 
  
 };

export default OperationDatatable;

